/**
 * UpgradePrompt — shown in place of a tool's normal content when the backend
 * blocks the call with { code: 'PLAN_UPGRADE_REQUIRED' } (see requireTool in
 * backend/src/middleware/planAccessMiddleware.js). Tools stay visible/linkable
 * in the nav on purpose (Starter users can see what they're missing) — this
 * is what they hit once they actually open one, instead of a raw error banner.
 */

import { useNavigate } from 'react-router-dom'
import { V2, V2Card, PrimaryBtn } from './JaiV2'
import { JAI_FONTS } from './JaiBrand'
import { STAT_GLYPHS } from '../config/statGlyphs'
import { IS_NATIVE_APP } from '../services/runtime'

const TOOL_NAMES = {
  'draft-board':       'Draft Room',
  'waiver-wire':       'Waiver Wire',
  'trade-analyser':    'Trade Analyser',
  'player-analyser':   'Player Analyser',
  'team-analyser':     'Team Analyser',
  'opponent-scout':    'Opponent Scout',
  'notes':             'My Notes',
  'schedule-surgeon':  'Schedule Surgeon',
  'injury-insurance':  'Injury Insurance',
}

export default function UpgradePrompt({ tool, message }) {
  const navigate = useNavigate()
  const toolName = TOOL_NAMES[tool] || 'This tool'

  return (
    <V2Card pad="36px 24px" style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 22, marginBottom: 10 }}>{STAT_GLYPHS.locked}</div>
      <div style={{ fontSize: 15, fontWeight: 700, color: V2.navy, marginBottom: 6, fontFamily: JAI_FONTS.tight }}>
        {toolName} isn't on your plan yet
      </div>
      {/* Guideline 3.1.1: on native this can never show a button, a link, a
          price, or the word "website" — a locked feature just states a fact.
          The server-supplied `message` is ignored here on purpose: several
          PLAN_UPGRADE_REQUIRED responses (planAccessMiddleware.js) say things
          like "...or upgrade for a higher limit", which is exactly the kind
          of purchase-adjacent copy that isn't allowed to render on iOS. Web
          keeps the richer, server-written message and the link to Pricing. */}
      <p style={{ fontSize: 13, color: V2.mute, margin: '0 auto 20px', maxWidth: 340, lineHeight: 1.5 }}>
        {IS_NATIVE_APP
          ? "This isn't part of your current plan."
          : (message || "This tool isn't included in your current plan.")}
      </p>
      {!IS_NATIVE_APP && (
        <PrimaryBtn onClick={() => navigate(`/pricing?upgrade=${tool}`)}>
          See plans →
        </PrimaryBtn>
      )}
    </V2Card>
  )
}
